import { FC, useCallback } from "react";
import { useAppDispatch } from "@/store/hooks";
import { WidgetSetupDateRangeWithInheritance } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/date-range/WidgetSetupDateRangeWithInheritance";
import { billingSummaryInheritanceChangeThunk } from "@/store/dashboards/thunks/widgets/billing-summary/widget-change/billingSummaryInheritanceChangeThunk";
import { WidgetSetupDateRangeSelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/toolbar/WidgetSetupDateRangeSelect";
import { Dates } from "@/services/cloudchipr.api";
import { billingSummaryDateChangeThunk } from "@/store/dashboards/thunks/widgets/billing-summary/widget-change/billingSummaryDateChangeThunk";

export const BillingSummarySetupDateRange: FC = () => {
  const dispatch = useAppDispatch();

  const syncWithDashboardHandler = useCallback(
    (checked: boolean) => {
      dispatch(billingSummaryInheritanceChangeThunk(checked));
    },
    [dispatch],
  );

  const dateRangeChangeHandler = useCallback(
    (dates: Dates) => {
      dispatch(billingSummaryDateChangeThunk(dates));
    },
    [dispatch],
  );

  return (
    <WidgetSetupDateRangeWithInheritance onChange={syncWithDashboardHandler}>
      <WidgetSetupDateRangeSelect onDateChange={dateRangeChangeHandler} />
    </WidgetSetupDateRangeWithInheritance>
  );
};
